import { createClient } from "@supabase/supabase-js";

import { SB_STORAGE_KEY } from "consts";

export const createSupabaseClient = (storageKey = SB_STORAGE_KEY) =>
  createClient(process.env.NX_SUPABASE_PROJECT_URL, process.env.NX_SUPABASE_API_KEY, {
    auth: {
      storageKey
    }
  });

// Session kept in memory only: nothing in localStorage, no other tab can read it
// Auto refresh off so the session is not kept alive past the password update
export const createInMemorySupabaseClient = () =>
  createClient(process.env.NX_SUPABASE_PROJECT_URL, process.env.NX_SUPABASE_API_KEY, {
    auth: {
      persistSession: false,
      autoRefreshToken: false,
      detectSessionInUrl: false
    }
  });

export const supabase = createSupabaseClient();

export type LocateSupabaseClient = typeof supabase;
